import React from 'react';
import Modal, { ModalProps } from '@mui/material/Modal';
import { Backdrop, Fade } from '@mui/material';
import useStyles from './Modal.styles.ts';
import Box from '@mui/material/Box';

interface ModalContainerProps extends ModalProps {
  contentStyle?: object;
}

const ModalContainer: React.FC<ModalContainerProps> = (props) => {
  const classes = useStyles();
  return (
    <Modal
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      {...props}>
      <Fade in={props.open}>
        <Box sx={props.contentStyle ? props.contentStyle : classes.modalContent}>
          {props.children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ModalContainer;
